import httpClient from './httpClient'

export default {
  async setVideoToOfflineEnabled(videoId, offlineData) {
    let ret = await httpClient.post(`app/${videoId}`, offlineData)
    return ret
  },
}
